<template>
  <div class="fxRow registerWrap">
    <Header></Header>
    <div class="firmBgImg">
      <Carousel></Carousel>
    </div>
    <div class="fxRow msRegister">
      <div class="fromWrap">
        <div class="msTitle">
          <span class="crp black45 fwb blueDark">{{ $t("forget.emailFind") }}</span>
        </div>
        <div>
          <p class="black88 fs14 pb12">{{ $t("forget.emailFindDescribe") }}</p>
          <el-form :model="emailForm" :rules="emailRules" ref="emailForm" label-width="0px" @submit.native.prevent class="msContent">
            <el-form-item prop="email" class="wdb100 mb50">
              <el-input
                type="text"
                v-model="emailForm.email"
                :placeholder="$t('forget.emailPlaceholder')"
                @keyup.enter.native="submitForm"
                v-regexFilter="$halfWidthRegex"
              ></el-input>
            </el-form-item>
            <div class="wdb100 login-btn">
              <el-button type="primary" @click="submitForm">{{ $t("forget.affirm") }}</el-button>
            </div>
          </el-form>

          <div class="wdb100 pt6">
            <p class="tar black88 loginTips">
              {{ $t("common.alreadyHave") }}?
              <router-link to="/login">{{ $t("common.goLogin") }}</router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="footBox">
      <p class="black88 fs12">
        {{ $t("login.copyright") }}
        <a href="https://beian.miit.gov.cn/" target="_blank" class="blue">{{ $t("login.records") }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import { postRequest } from "@/api/common";
import Header from "./components/Header";
import Carousel from "./components/Carousel";
import { mapGetters } from "vuex";
export default {
  name: "Forget",
  data() {
    return {
      emailForm: {
        email: null,
      },
      clickSwitch: true, // 防止恶意提交
      emailRules: {
        email: [
          {
            required: true,
            message: this.$t("register.emailHint"),
            trigger: "submit",
          },
          {
            type: "email",
            message: this.$t("common.regular.email"),
            trigger: "submit",
          },
        ],
      },
    };
  },
  components: {
    Header,
    Carousel,
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
  },
  methods: {
    // 确认修改按钮
    submitForm() {
      this.$refs["emailForm"].validate(valid => {
        if (valid) {
          if (this.clickSwitch) {
            this.clickSwitch = false;
            // 通过邮箱找回
            postRequest("/resetPwdByEmail", {
              email: this.emailForm.email,
            })
              .then(res => {
                // this.$message.success(this.$t('common.info.emailSend'))
                this.$router.push("/remind?type=2");
              })
              .catch(err => {
                this.clickSwitch = true;
              });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.msRegister {
  ::v-deep {
    .el-button--primary.is-plain:focus {
      background: #0072ff;
      border-color: #0072ff;
    }

    .el-button--primary.is-plain:hover {
      background: #0072ff;
      border-color: #0072ff;
    }

    .el-input-group__prepend {
      background: #ffffff;
      border-color: #e1ecff;
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    }

    .el-input-group__prepend .el-select {
      height: 48px;
      line-height: 48px;
    }

    .el-input-group .el-input__inner {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }

    .el-input__inner {
      background: #ffffff;
      border-color: #e1ecff;
      border-radius: 6px;
      height: 50px;
      line-height: 50px;
    }
  }
}

.registerWrap {
  width: 100%;
  min-width: 1200px;
  height: 100%;
  min-height: 800px;
  background: #f1f5fc;
  position: relative;

  ::v-deep {
    .el-input__inner {
      height: 50px;
      line-height: 50px;
      font-size: 14px;
    }
  }
}

.firmBgImg {
  width: 60%;
  height: 100%;
  background: #f1f5fc;
}

.msRegister {
  width: 40%;
  height: 100%;
  background: #fafcff;
  box-shadow: 0px 21px 40px 0px rgba(208, 229, 255, 0.26);
}

.fromWrap {
  width: 430px;
  margin: 0px auto;
}

.msTitle {
  width: 100%;
  text-align: center;
  padding-bottom: 60px;
  font-size: 22px;
}

.loginline {
  color: #e6e6e6;
}

.msContent {
  width: 100%;
}

.login-btn {
  text-align: center;
}

.login-btn button {
  width: 100%;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
}

.loginTips,
.forgetTips {
  font-size: 14px;
  line-height: 36px;
}

.loginTips a {
  color: #0072ff;
}

.forgetTips a {
  color: #667288;
}

.protocol:hover {
  color: #0072ff;
}

.footBox {
  position: absolute;
  bottom: 14px;
  left: 0;
  width: 60%;
  text-align: center;
  z-index: 10000;
}
</style>
